module.exports = __webpack_public_path__ + "img/error-toc-autocaptura.d3ac81e4.svg";